"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthStatus = void 0;
var AuthStatus = {
    LOADING: 'loading',
    LOGGED_IN: 'loggedIn',
    LOGGED_OUT: 'loggedOut',
};
exports.AuthStatus = AuthStatus;
